module.exports = __webpack_public_path__ + "static/media/graduation.e218bf7d.jpg";